import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=5821e422&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=5821e422&prod&lang=scss&scoped=true"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=5821e422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821e422",
  null
  
)

export default component.exports